// Names for the file types in an attachment field's accept list, for the texts that tell users which
// formats to use.

const names = {
  "application/pdf": "PDF",
  "image/jpeg": "JPG",
  "image/jpg": "JPG",
  "image/png": "PNG",
  "image/webp": "WebP",
};

export function formatName(type) {
  if (names[type]) return names[type];
  if (type.startsWith("image/")) return type.replace("image/", "").toUpperCase();
  if (type.includes("/")) return type.split("/")[1].toUpperCase();
  return type.toUpperCase();
}

// Joins names as "A", "A or B" or "A, B or C", with or in the user's language.
export function joinWithOr(items, or) {
  const unique = Array.from(new Set(items));
  if (unique.length <= 1) return unique.join("");
  return `${unique.slice(0, -1).join(", ")} ${or} ${unique[unique.length - 1]}`;
}

// The image formats to name when a field takes any image: those every browser shows and the print
// service can put in the application.
const imageFormats = ["image/png", "image/jpeg", "image/webp"];

// Names the formats a file for a field with this accept list can be saved as.
export function formatsToSaveAs(accept, or) {
  const types = accept
    .split(",")
    .map((type) => type.trim())
    .flatMap((type) => (type === "image/*" ? imageFormats : [type]));
  return joinWithOr(types.map(formatName), or);
}
